import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { Employee, IEmployee } from '@/types/user'

export const useGetEmployees = (type?: Employee) => {
    return useAppQuery<IEmployee[]>({
        queryKey: ['employees'],
        queryFn: () =>
            createInstance({
                url: '/employees',
                method: 'GET',
                params: {
                    Type: type,
                },
            }),
        select: (data) => data.filter((item) => !!item.badgeNumber),
    })
}
